export default "Stupi square is dumb and defenselesss, can sussy cireoil protecc?";